import { useMemo } from 'react';

import { getJobBoardClientNameFromLocalStorage } from 'helpers/jobBoardClientNameLocalStorage/getJobBoardClientNameFromLocalStorage';

export const useIsReasonableAdjustmentAvailable = () => {
  const currentClient = getJobBoardClientNameFromLocalStorage();

  return useMemo(() => {
    switch (currentClient) {
      case 'staging-scts':
      case 'scts':      
      case 'staging-morrisons':
      case 'morrisons':
      case 'staging-mands-joy':
      case 'mands-joy':
      case 'staging-moj':
      case 'moj':
      case 'staging-asda':
      case 'asda':
        return false;
      default:
        return true;
    }
  }, [currentClient]);
};
